import { render } from "./ThreeBackground.vue?vue&type=template&id=30e34152&scoped=true"
import script from "./ThreeBackground.vue?vue&type=script&lang=js"
export * from "./ThreeBackground.vue?vue&type=script&lang=js"

import "./ThreeBackground.vue?vue&type=style&index=0&id=30e34152&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e34152"]])

export default __exports__